/* SPDX-License-Identifier: AGPL-3.0-or-later */

import { Component, OnInit, input } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatCard } from '@angular/material/card';
import { HeaderCardComponent } from '../header-card/header-card.component';
import { PartyPictureCardComponent } from '../party-picture-card/party-picture-card.component';
import { SharedMediaEndpointService, SharedMediaMetadataDto } from '@api';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RouterModule } from '@angular/router';
import { MatOption } from '@angular/material/core';
import { MatFormField, MatLabel, MatSelect } from '@angular/material/select';
import { MatIcon } from '@angular/material/icon';
import { CopyLinkService } from 'src/app/services/copy-link.service';

@Component({
  selector: 'app-party-pics-approve',
  standalone: true,
  imports: [
    MatButton,
    MatCard,
    MatOption,
    MatSelect,
    MatLabel,
    MatIcon,
    MatFormField,
    HeaderCardComponent,
    RouterModule,
    PartyPictureCardComponent,
  ],
  templateUrl: './party-pics-approve.component.html',
  styleUrls: ['./party-pics-approve.component.scss'],
})
export class PartyPicsApproveComponent implements OnInit {
  tournamentId = input.required<number>();
  pictures: SharedMediaMetadataDto[] = [];
  selectedState = 'ALL';
  pictureStates = ['APPROVED', 'PENDING', 'REJECTED', 'ALL'];

  constructor(
    private sharedMediaService: SharedMediaEndpointService,
    private copyLinkService: CopyLinkService,
    private snackBar: MatSnackBar,
  ) {}

  getPictures(): SharedMediaMetadataDto[] {
    return this.pictures;
  }

  ngOnInit(): void {
    this.fetchPictures();
  }

  fetchPictures(): void {
    this.sharedMediaService.getSharedMediaByTournament(this.tournamentId()).subscribe({
      next: (data: SharedMediaMetadataDto[]) => {
        if (this.selectedState === 'ALL') {
          this.pictures = data;
        } else {
          this.pictures = data.filter(picture => picture.state === this.selectedState);
        }
      },
      error: error => {
        console.error('Error fetching pictures:', error);
      },
    });
  }

  openCopyPublicLinkDialog() {
    this.copyLinkService.openDialog({
      link: window.origin + '/#/tournaments/' + this.tournamentId() + '/public-gallery',
      title: 'Link to public picture gallery',
    });
  }
}
